export const POSTHOG_KEY = process.env.NEXT_PUBLIC_POSTHOG_KEY || ""
export const POSTHOG_HOST = process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://ph.loophome.co"

declare global {
  interface Window {
    posthog?: {
      init: (key: string, options: any) => void
      isFeatureEnabled: (key: string) => boolean
      getFeatureFlag: (key: string) => boolean | string | undefined
      onFeatureFlags: (callback: () => void) => void
      capture: (event: string, properties?: any) => void
      captureException: (error: Error, additionalProperties?: any) => void
    }
  }
}
